import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const EditIcon: FC<SvgProps> = (props) => {
    return (
        <Svg {...props}>
            <Path fill={ColorEnum.Transparent} d="M0 0h24v24H0z" />
            <Path
                fill={ColorEnum.BRICK_600}
                d="m14.975 11.125-2.1-2.1-5.15 5.15c-.1.1-.175.212-.225.337-.05.125-.075.255-.075.388v1.175c0 .133.05.25.15.35.1.1.217.15.35.15H9.1c.133 0 .263-.025.388-.075a.999.999 0 0 0 .337-.225l5.15-5.15Zm.6-.6.7-.7c.2-.2.3-.433.3-.7 0-.267-.1-.5-.3-.7l-.7-.7a.96.96 0 0 0-.7-.3c-.267 0-.5.1-.7.3l-.7.7 2.1 2.1ZM12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
            />
        </Svg>
    )
}

export default EditIcon
